import axios from "axios";

import Config from "../../config";

const getActionCriarFunil = data => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/chat/funil/criar`,
        data
    });
};

export default getActionCriarFunil;
